import React from 'react';
import '../template-file-css/document-file-template.css';


export const LCS_CrisisIntakeAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='LCS_CrisisIntakeAssessment' className='file-pdf-document'>
            <div className='file-template'> 


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian Name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Relationship:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtParentGuardianName" name="txtParentGuardianName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtRelationship" name="txtRelationship" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p  className='w-750'>
                    <span className='eleHeader'>Address:</span>
                    <textarea id="txtAddress_2" name="txtAddress_2" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Intake:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Assessment completed:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPhone_2" name="txtPhone_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateIntake" name="txtDateIntake" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbYes" name="rbYesNo" className='add-only' value="YES" /> YES
                             &nbsp;
                            <input type="radio" id="rbNo" name="rbYesNo" className='add-only' value="NO" /> NO
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <h3>Education:</h3>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current grade or Last grade completed:</span></td>
                        <td className='w-375'><span className='eleHeader'>School:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtGrade" name="txtGrade" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtSchool" name="txtSchool" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <h3>Substance Abuse:</h3>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbSubstanceYes" name="rbSubstanceYesNo" className='add-only' value="YES" /> YES  &nbsp;
                            <input type="radio" id="rbSubstanceNo" name="rbSubstanceYesNo" className='add-only' value="NO" /> NO
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Drug of Choice:</span></td>
                        <td className='w-375'><span className='eleHeader'>Last time Used:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtDrugChoice" name="txtDrugChoice" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtLastUsed" name="txtLastUsed" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Presenting Problem:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Where did the crisis occur:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" value='Home' id="cbHome" name="cbHome" className='add-only' /> Home   &nbsp;
                            <input type="checkbox" value='School' id="cbSchool" name="cbSchool" className='add-only' /> School   &nbsp;
                            <input type="checkbox" value='Community' id="cbCommunity" name="cbCommunity" className='add-only' /> Community   &nbsp;
                            <input type="checkbox" value='Job' id="cbJob" name="cbJob" className='add-only' /> Job   &nbsp;
                            <br/>
                            <input type="checkbox" value='Other' id="cbOther" name="cbOther" className='add-only' /> Other(specify):   &nbsp;
                            <textarea id="txtOther" name="txtOther" className='add-only'></textarea>
                        </td>
                    </tr>

                </table>
                <p  className='w-750'>
                            <span className='eleHeader'>Describe the Incident that occurred-  </span> 
                    please include specific dates, times, intensity of behavior, precipitating events/stressors that contributed to crisis, and what was done to calm the client down
                    <textarea id="txtDescribeIncident" name="txtDescribeIncident" className='add-only'></textarea>
                </p>
                <p  className='w-750'> 
                            <span className='eleHeader'>Were the police called as a result of this incident? </span>
                            <input type="radio" id="rbIncidentYes" name="rbIncidentYesNo" className='add-only' value="YES" /> YES  &nbsp;
                            <input type="radio" id="rbIncidentNo" name="rbIncidentYesNo" className='add-only' value="NO" /> NO
                </p>
                <p  className='w-750'>
                    If yes, what were the results/the outcome?
                    <textarea id="txtOutcome" name="txtOutcome" className='add-only'></textarea>
                </p>
                <p  className='w-750'> 
                            <span className='eleHeader'> Is the client at risk of hospitalization or out of home placement?</span>
                            <input type="radio" id="rbHospitalizationYes" name="rbHospitalizationYesNo" className='add-only' value="YES" /> YES  &nbsp;
                            <input type="radio" id="rbHospitalizationNo" name="rbHospitalizationYesNo" className='add-only' value="NO" /> NO
                </p>
                <p  className='w-750'> 
                            <span className='eleHeader'> Is the client unable to recognize and/or avoid situations that risk personal safety?</span>
                            <input type="radio" id="rbPersonalSafetyYes" name="rbPersonalSafetyYesNo" className='add-only' value="YES" /> YES  &nbsp;
                            <input type="radio" id="rbPersonalSafetyNo" name="rbPersonalSafetyYesNo" className='add-only' value="NO" /> NO
                </p>
                <p  className='w-750'> 
                            <span className='eleHeader'> Is client engaging in significantly inappropriate social behavior?</span>
                            <input type="radio" id="rbSocialBehaviorYes" name="rbSocialBehaviorYesNo" className='add-only' value="YES" /> YES  &nbsp;
                            <input type="radio" id="rbSocialBehaviorNo" name="rbSocialBehaviorYesNo" className='add-only' value="NO" /> NO
                </p>
                <p  className='w-750'> 
                            <span className='eleHeader'> Current Medications?</span>
                            <input type="radio" id="rbCurrentMedicationsYes" name="rbCurrentMedicationsYesNo" className='add-only' value="YES" /> YES  &nbsp;
                            <input type="radio" id="rbCurrentMedicationsNo" name="rbCurrentMedicationsYesNo" className='add-only' value="NO" /> NO
                </p>
                <p  className='w-750'> 
                            <span className='eleHeader'> Is client compliant with current medications?</span>
                            <input type="radio" id="rbComplianCurrentMedicationsYes" name="rbComplianCurrentMedicationsYesNoNa" className='add-only' value="YES" /> YES  &nbsp;
                            <input type="radio" id="rbComplianCurrentMedicationsNo" name="rbComplianCurrentMedicationsYesNoNa" className='add-only' value="NO" /> NO  &nbsp;
                            <input type="radio" id="rbComplianCurrentMedicationsNa" name="rbComplianCurrentMedicationsYesNoNa" className='add-only' value="Na" /> N/A
                </p> 
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Dose</span></td>
                        <td className='w-150'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-150'><span className='eleHeader'>Prescribing Doctor</span></td>
                        <td className='w-150'><span className='eleHeader'>Comments</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtMedication_1" name="txtMedication_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDose_1" name="txtDose_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_1" name="txtFrequency_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDoctor_1" name="txtDoctor_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtComments_1" name="txtComments_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtMedication_2" name="txtMedication_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDose_2" name="txtDose_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequency_2" name="txtFrequency_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDoctor_2" name="txtDoctor_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtComments_2" name="txtComments_2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p  className='w-750'>
                    <span className='eleHeader'>Treatment Goals/Plan:</span>
                    be specific and make sure that data is collected at time of crisis.
                    <textarea id="txtTreatmentGoalsPlan" name="txtTreatmentGoalsPlan" className='add-only'></textarea>
                </p>


                <p  className='w-750'>
                    <h3>Mental Status Profile:</h3> 
                    <span className='small'>(Check all that apply)</span>
                </p>
                <p  className='w-750'>
                    <span className='eleHeader'> Appearance:</span> 
                    <input type="checkbox" value='Appearance_1' id="cbAppearanceWNL" name="cbAppearanceWNL" className='add-only' />  WNL &nbsp; &nbsp;
                    <input type="checkbox" value='Appearance_2' id="cbAppearanceOlderYounger" name="cbAppearanceOlderYounger" className='add-only' /> Appears age Older/younger &nbsp;
                    <input type="checkbox" value='Appearance_3' id="cbAppearancePoorHygiene" name="cbAppearancePoorHygiene" className='add-only' /> Poor Hygiene &nbsp;
                    <input type="checkbox" value='Appearance_4' id="cbAppearanceUnkempt" name="cbAppearanceUnkempt" className='add-only' /> Unkempt &nbsp;
                    <input type="checkbox" value='Appearance_5' id="cbAppearanceInappropriateClothing" name="cbAppearanceInappropriateClothing" className='add-only' /> Inappropriate Clothing &nbsp;
                </p>
                <p  className='w-750'>
                    <span className='eleHeader'> Behavior/Motor Disturbance:</span> 
                    <input type="checkbox" value='Behavior_1' id="cbBehaviorWNL" name="cbBehaviorWNL" className='add-only' />  WNL &nbsp; &nbsp;
                    <input type="checkbox" value='Behavior_2' id="cbBehaviorPsychomotorRetardation_1" name="cbBehaviorPsychomotorRetardation_1" className='add-only' /> Psychomotor Retardation &nbsp;
                    <input type="checkbox" value='Behavior_3' id="cbBehaviorAggressive" name="cbBehaviorAggressive" className='add-only' /> Aggressive &nbsp;
                    <input type="checkbox" value='Behavior_4' id="cbBehaviorIntrusive" name="cbBehaviorIntrusive" className='add-only' /> Intrusive &nbsp;
                    <input type="checkbox" value='Behavior_5' id="cbBehaviorImpulsecontrol" name="cbBehaviorImpulsecontrol" className='add-only' /> Impulse control &nbsp;
                    <input type="checkbox" value='Behavior_6' id="cbBehaviorOppositional" name="cbBehaviorOppositional" className='add-only' /> Oppositional &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Orientation:</span>
                    <input type="checkbox" value='Orientation_1' id="cbOrientationWNL" name="cbOrientationWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Orientation_2' id="cbOrientationDisoriented" name="cbOrientationDisoriented" className='add-only' /> Disoriented &nbsp;
                    <input type="checkbox" value='Orientation_3' id="cbOrientationTime" name="cbOrientationTime" className='add-only' /> Time &nbsp;
                    <input type="checkbox" value='Orientation_4' id="cbOrientationPlace" name="cbOrientationPlace" className='add-only' /> Place<label>	</label>
                    <input type="checkbox" value='Orientation_5' id="cbOrientationPerson" name="cbOrientationPerson" className='add-only' /> Person<label>		</label>
                    <input type="checkbox" value='Orientation_6' id="cbOrientationSituation" name="cbOrientationSituation" className='add-only' /> Situation &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Speech:</span>
                    <input type="checkbox" value='Speech_1' id="cbSpeechWNL" name="cbSpeechWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Speech_2' id="cbSpeechPressured" name="cbSpeechPressured" className='add-only' /> Pressured &nbsp;
                    <input type="checkbox" value='Speech_3' id="cbSpeechSlowed" name="cbSpeechSlowed" className='add-only' /> Slowed &nbsp;
                    <input type="checkbox" value='Speech_4' id="cbSpeechSoftLoud" name="cbSpeechSoftLoud" className='add-only' /> Soft/loud &nbsp;
                    <input type="checkbox" value='Speech_5' id="cbSpeechImpoverished" name="cbSpeechImpoverished" className='add-only' /> Impoverished &nbsp;
                    <input type="checkbox" value='Speech_6' id="cbSpeechSlurred" name="cbSpeechSlurred" className='add-only' /> Slurred &nbsp;
                    <input type="checkbox" value='Speech_7' id="cbSpeechArticulationErrors" name="cbSpeechArticulationErrors" className='add-only' /> Articulation errors &nbsp;

                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Mood:</span>
                    <input type="checkbox" value='Mood_1' id="cbMoodWNL" name="cbMoodWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Mood_2' id="cbMoodDepressed" name="cbMoodDepressed" className='add-only' /> Depressed &nbsp;
                    <input type="checkbox" value='Mood_3' id="cbMoodAngryHostile" name="cbMoodAngryHostile" className='add-only' /> Angry/Hostile &nbsp;
                    <input type="checkbox" value='Mood_4' id="cbMoodEuphoric" name="cbMoodEuphoric" className='add-only' /> Euphoric &nbsp;
                    <input type="checkbox" value='Mood_5' id="cbMoodAnxious" name="cbMoodAnxious" className='add-only' /> Anxious &nbsp;
                    <input type="checkbox" value='Mood_6' id="cbMoodIrritable" name="cbMoodIrritable" className='add-only' /> Irritable &nbsp;
                    <input type="checkbox" value='Mood_7' id="cbMoodWithdrawn" name="cbMoodWithdrawn" className='add-only' /> Withdrawn &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Affect:</span>
                    <input type="checkbox" value='Affect_1' id="cbAffectWNL" name="cbAffectWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Affect_2' id="cbAffectConstricted" name="cbAffectConstricted" className='add-only' /> Constricted &nbsp;
                    <input type="checkbox" value='Affect_3' id="cbAffectFlat" name="cbAffectFlat" className='add-only' /> Flat &nbsp;
                    <input type="checkbox" value='Affect_4' id="cbAffectLabile" name="cbAffectLabile" className='add-only' /> Labile &nbsp;
                    <input type="checkbox" value='Affect_5' id="cbAffectInappropriate" name="cbAffectInappropriate" className='add-only' /> Inappropriate &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Thought Content:</span>
                    <input type="checkbox" value='ThoughtContent_1' id="cbThoughtContentWNL" name="cbThoughtContentWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='ThoughtContent_2' id="cbThoughtContentDelusions" name="cbThoughtContentDelusions" className='add-only' /> Delusions &nbsp;
                    <input type="checkbox" value='ThoughtContent_3' id="cbThoughtContentGrandiose" name="cbThoughtContentGrandiose" className='add-only' /> Grandiose &nbsp;
                    <input type="checkbox" value='ThoughtContent_4' id="cbThoughtContentIdeasReference" name="cbThoughtContentIdeasReference" className='add-only' /> Ideas of reference &nbsp;
                    <input type="checkbox" value='ThoughtContent_5' id="cbThoughtContentParanoid" name="cbThoughtContentParanoid" className='add-only' /> Paranoid &nbsp;
                    <input type="checkbox" value='ThoughtContent_6' id="cbThoughtContentObsession" name="cbThoughtContentObsession" className='add-only' /> Obsession &nbsp;
                    <input type="checkbox" value='ThoughtContent_7' id="cbThoughtContentPhobias" name="cbThoughtContentPhobias" className='add-only' /> Phobias &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Thought Process:</span>
                    <input type="checkbox" value='ThoughtProcess_1' id="cbThoughtProcessWNL" name="cbThoughtProcessWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='ThoughtProcess_2' id="cbThoughtProcessLooseAssociations" name="cbThoughtProcessLooseAssociations" className='add-only' /> Loose Associations &nbsp;
                    <input type="checkbox" value='ThoughtProcess_3' id="cbThoughtProcessFightIdeas" name="cbThoughtProcessFightIdeas" className='add-only' /> Fight of ideas &nbsp;
                    <input type="checkbox" value='ThoughtProcess_4' id="cbThoughtProcessCircumstantial" name="cbThoughtProcessCircumstantial" className='add-only' /> Circumstantial &nbsp;
                    <input type="checkbox" value='ThoughtProcess_5' id="cbThoughtProcessBlocking" name="cbThoughtProcessBlocking" className='add-only' /> Blocking &nbsp;
                    <input type="checkbox" value='ThoughtProcess_6' id="cbThoughtProcessTangential" name="cbThoughtProcessTangential" className='add-only' /> Tangential &nbsp;
                    <input type="checkbox" value='ThoughtProcess_7' id="cbThoughtProcessPreservative" name="cbThoughtProcessPreservative" className='add-only' /> Preservative &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Perception:</span>
                    <input type="checkbox" value='Perception_1' id="cbPerceptionWNL" name="cbPerceptionWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Perception_2' id="cbPerceptionHallucinations" name="cbPerceptionHallucinations" className='add-only' /> Hallucinations &nbsp;
                    <input type="checkbox" value='Perception_3' id="cbPerceptionAuditory" name="cbPerceptionAuditory" className='add-only' /> Auditory &nbsp;
                    <input type="checkbox" value='Perception_4' id="cbPerceptionVisual" name="cbPerceptionVisual" className='add-only' /> Visual &nbsp;
                    <input type="checkbox" value='Perception_5' id="cbPerceptionOlfactory" name="cbPerceptionOlfactory" className='add-only' /> Olfactory &nbsp;
                    <input type="checkbox" value='Perception_6' id="cbPerceptionTactile" name="cbPerceptionTactile" className='add-only' /> Tactile &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Memory:</span>
                    <input type="checkbox" value='Memory_1' id="cbMemoryWNL" name="cbMemoryWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Memory_2' id="cbMemoryImpaired" name="cbMemoryImpaired" className='add-only' /> Impaired &nbsp;
                    <input type="checkbox" value='Memory_3' id="cbMemoryRecent" name="cbMemoryRecent" className='add-only' /> Recent &nbsp;
                    <input type="checkbox" value='Memory_4' id="cbMemoryRemote" name="cbMemoryRemote" className='add-only' /> Remote &nbsp;
                    <input type="checkbox" value='Memory_5' id="cbMemoryImmediate" name="cbMemoryImmediate" className='add-only' /> Immediate &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Appetite:</span>
                    <input type="checkbox" value='Appetite_1' id="cbAppetiteWNL" name="cbAppetiteWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Appetite_2' id="cbAppetiteIncreased" name="cbAppetiteIncreased" className='add-only' /> Increased &nbsp;
                    <input type="checkbox" value='Appetite_3' id="cbAppetiteDecreased" name="cbAppetiteDecreased" className='add-only' /> Decreased &nbsp;
                    <input type="checkbox" value='Appetite_4' id="cbAppetiteWeight" name="cbAppetiteWeight" className='add-only' /> Weight &nbsp;
                    <input type="checkbox" value='Appetite_5' id="cbAppetiteGain" name="cbAppetiteGain" className='add-only' /> Gain &nbsp;
                    <input type="checkbox" value='Appetite_6' id="cbAppetiteLoss" name="cbAppetiteLoss" className='add-only' /> Loss &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Sleep:</span>
                    <input type="checkbox" value='Sleep_1' id="cbSleepWNL" name="cbSleepWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Sleep_2' id="cbSleepHypersomnia" name="cbSleepHypersomnia" className='add-only' /> Hypersomnia &nbsp;
                    <input type="checkbox" value='Sleep_3' id="cbSleepOnsetProblem" name="cbSleepOnsetProblem" className='add-only' /> Onset Problem &nbsp;
                    <input type="checkbox" value='Sleep_4' id="cbSleepMaintenanceProblem" name="cbSleepMaintenanceProblem" className='add-only' /> Maintenance Problem &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Attention:</span>
                    <input type="checkbox" value='Attention_1' id="cbAttentionWNL" name="cbAttentionWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Attention_2' id="cbAttentionDistractible" name="cbAttentionDistractible" className='add-only' /> Distractible &nbsp;
                    <input type="checkbox" value='Attention_3' id="cbAttentionHyperVigilant" name="cbAttentionHyperVigilant" className='add-only' /> Hyper vigilant &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Concentration:</span>
                    <input type="checkbox" value='Concentration_1' id="cbConcentrationWNL" name="cbConcentrationWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Concentration_2' id="cbConcentrationImpaired" name="cbConcentrationImpaired" className='add-only' /> Impaired &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Judgment:</span>
                    <input type="checkbox" value='Judgment_1' id="cbJudgmentWNL" name="cbJudgmentWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Judgment_2' id="cbJudgmentImpaired" name="cbJudgmentImpaired" className='add-only' /> Impaired &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Insight:</span>
                    <input type="checkbox" value='Insight_1' id="cbInsightWNL" name="cbInsightWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Insight_2' id="cbInsightBlaming" name="cbInsightBlaming" className='add-only' /> Blaming &nbsp;
                    <input type="checkbox" value='Insight_3' id="cbInsightLittle" name="cbInsightLittle" className='add-only' /> Little &nbsp;
                    <input type="checkbox" value='Insight_4' id="cbInsightNone" name="cbInsightNone" className='add-only' /> None &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Impulse Control:</span>
                    <input type="checkbox" value='ImpulseControl_1' id="cbImpulseControlWNL" name="cbImpulseControlWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='ImpulseControl_2' id="cbImpulseControlImpaired" name="cbImpulseControlImpaired" className='add-only' /> Impaired &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Suicide:</span>
                    <input type="checkbox" value='Suicide_1' id="cbSuicideWNL" name="cbSuicideWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='Suicide_2' id="cbSuicideHxAttempts" name="cbSuicideHxAttempts" className='add-only' /> HX of attempts &nbsp;
                    <input type="checkbox" value='Suicide_3' id="cbSuicideCurrentAttempt" name="cbSuicideCurrentAttempt" className='add-only' /> Current Attempt &nbsp;
                    <input type="checkbox" value='Suicide_4' id="cbSuicideIdeation" name="cbSuicideIdeation" className='add-only' /> Ideation &nbsp;
                </p>
                <p  className='w-750'> 
                    <span className='eleHeader'> Homicide Potential:</span>
                    <input type="checkbox" value='HomicidePotential_1' id="cbHomicidePotentialWNL" name="cbHomicidePotentialWNL" className='add-only' />   WNL &nbsp;
                    <input type="checkbox" value='HomicidePotential_2' id="cbHomicidePotentialHxAssaults" name="cbHomicidePotentialHxAssaults" className='add-only' /> HX of assaults &nbsp;
                    <input type="checkbox" value='HomicidePotential_3' id="cbHomicidePotentialAttempted" name="cbHomicidePotentialAttempted" className='add-only' /> Attempted &nbsp;
                    <input type="checkbox" value='HomicidePotential_4' id="cbHomicidePotentialIdeation" name="cbHomicidePotentialIdeation" className='add-only' /> Ideation &nbsp;
                </p>


                <h3>Discharge /Follow Up Plan:</h3> 

                <p  className='w-750'>
                    <span className='eleHeader'>Approximate discharge date from Crisis Intervention:</span>
                    <input type="date" id="txtDischargeDate" name="txtDischargeDate" className='add-only' />
                </p>
                <p  className='w-750'>
                    <span className='eleHeader'>Will recipient transition to CPST/PSR services?
                    </span>
                    <input type="radio" id="rbCpstPsrServicesYes" name="rbCpstPsrServicesYesNo" className='add-only' value="YES" /> YES  &nbsp;
                    <input type="radio" id="rbCpstPsrServicesNo" name="rbCpstPsrServicesYesNo" className='add-only' value="NO" /> NO
                </p>
                <p  className='w-750'>
                    If No, where will they be referred for follow-up care?
                    <textarea id="txtFollowUpCare" name="txtFollowUpCare" className='add-only'></textarea>
                </p> 

            </div>
        </form>

    )
}











